import React from 'react';
import { IoGameControllerOutline } from 'react-icons/io5';
import useLocalStorage from '../../hooks/useLocalStorage';
import { phases } from '../../config/app';

const GameCard = ({
  label,
  onClick,
  src,
}: {
  label: string;
  onClick: () => void;
  src?: string;
}) => (
  <div
    onClick={onClick}
    className="cursor-pointer group block max-w-xs rounded-lg p-8 bg-white ring-1 ring-slate-900/5 shadow-lg space-y-3 hover:bg-primary hover:ring-primary transition"
  >
    <div className="flex flex-col items-center gap-4">
      <img
        src={`../../../images/${src}`}
        alt={label}
        className="h-40 w-48 object-contain"
      />
    </div>
  </div>
);

const SelectGame: React.FC = () => {
  const [_, setPhase] = useLocalStorage('phase', '');

  const handleSetPhase = (phase: string) => {
    setPhase(phase);
    setTimeout(() => {
      window.location.assign('/sornthai');
    }, 100);
  };

  return (
    <div className="flex justify-center h-screen">
      <div className="my-auto w-full xl:w-2/4 rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full p-4 sm:p-12.5 xl:p-12">
          <div className="mb-9 flex gap-2">
            <h2 className="text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
              เลือกเกม
            </h2>
            <IoGameControllerOutline fontSize={25} className="self-center" />
          </div>

          <div className="flex flex-col xl:flex-row justify-around gap-6">
            {phases.map(({ key, src }) => (
              <GameCard
                key={key}
                label={key}
                src={src}
                onClick={() => handleSetPhase(key)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectGame;
